export const BASE = {
  name: 'survey-templates',
  path: '/sites/:siteId/survey-templates',
};
